import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getUserLocale from 'get-user-locale'
import _ from 'lodash'

Vue.use(VueI18n)

const AVAILABLE_LOCALE = ['fr']
const DEFAULT_LOCALE = 'fr'


// Si la langue définit par le browser n'est pas disponible, retourne null
const getBrowserLocale = () => {
  let iso639Code = _.head(getUserLocale().split('-'))
  return AVAILABLE_LOCALE.includes(iso639Code) ? iso639Code : null
}

const i18n = new VueI18n({
  locale: getBrowserLocale() || DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  silentFallbackWarn: true,
})


export {
  i18n
}
